<div class="button-box">
    <div *ngIf="device.status.statusCode === statusTypes.idle" class="button-box__item">
        <button nbButton [status]="'primary'" (click)="onCreatePrintFileFromDeviceModal()" [appPermissionDisabled]="permissions.Devices.Commands.Start">
            <nb-icon icon="play-circle-outline"></nb-icon>
            {{ 'device.buttons.print' | translate }}
        </button>
    </div>
    <div *ngIf="canPause" class="button-box__item">
        <button nbButton [status]="'info'" (click)="onCreateModalPause(device.id)" [appPermissionDisabled]="permissions.Devices.Commands.Pause">
            <nb-icon icon="pause-circle-outline"></nb-icon>
            {{ 'device.buttons.pause' | translate }}
        </button>
    </div>
    <div *ngIf="canStopPrinting" class="button-box__item">
        <button nbButton [status]="'danger'" (click)="onCreateModalStop(device.id)" [appPermissionDisabled]="permissions.Devices.Commands.Stop">
            <nb-icon icon="stop-circle-outline"></nb-icon>
            {{ 'device.buttons.stop' | translate }}
        </button>
    </div>
    <div *ngIf="isPaused" class="button-box__item">
        <button nbButton [status]="'primary'" (click)="onCreateModalResume(device.id)" [appPermissionDisabled]="permissions.Devices.Commands.Resume">
            <nb-icon icon="play-circle-outline"></nb-icon>
            {{ 'device.buttons.resume' | translate }}
        </button>
    </div>
</div>